module.exports = __webpack_public_path__ + "static/img/PROTEIN.dcb3f91e.svg";